import filter from 'lodash/filter';
import find from 'lodash/find';

export const formName = 'affiliateProfilePayoutSettingsForm';

export function mapStateToProps(state) {
	const { balances, payoutSystems } = state.affiliateProfile;

	const allowedPayoutSystems = filter(payoutSystems, (payoutSystem) => {
		return !!find(balances, { currency: payoutSystem.currency });
	});

	return {
		payoutSystems: payoutSystems || [],
		allowedPayoutSystems
	};
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/payout-settings/payout-settings-form/index.js